var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_481","data-name":"Group 481","transform":"translate(-10 -970.362)"},React.createElement("path",{"id":"Path_213","data-name":"Path 213","d":"M10,970.362v6H50v-6Zm0,13v6H50v-6Zm0,13v6H50v-6Z","fill":"#0d0c41"})));
}

Menu.defaultProps = {"width":"40","height":"32","viewBox":"0 0 40 32"};

module.exports = Menu;

Menu.default = Menu;
